import {
  AnalyticsEvent,
  EventParameters,
} from "@adsk/acc-issues-core/utils/analytics/analyticsTypes";

export class IssueEditBulkEditUnpublishEvent implements AnalyticsEvent {
  name = "issue.edit.bulk_edit.unpublish";
  parameters: EventParameters;

  constructor(params: { selectedCount: number }) {
    this.parameters = {
      ...params,
    };
  }
}
